import { v4 as uuidv4 } from 'uuid';

/**
 * Generates a UUID using the most appropriate method available.
 * Falls back to uuid library if crypto.randomUUID() is not available.
 * 
 * This handles cases where crypto.randomUUID() is not available in insecure contexts
 * (e.g., when accessing via IP address over HTTP on mobile devices).
 */
export function generateUUID(): string {
    // Check if crypto.randomUUID is available (secure context)
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
        try {
            return crypto.randomUUID();
        } catch (error) {
            console.warn('crypto.randomUUID() failed, falling back to uuid library:', error);
        }
    }
    
    // Fallback to uuid library
    return uuidv4();
}

export default generateUUID;
